import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  getAllGallarys,
  getGallaryByID,
  updateGallary,
} from "./services/gallary.services";
import { clearGallaryDetails } from "./gallarySlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateGallary: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const GallaryID = location.state?.GallaryID;
  const GallaryID = useAppSelector((state) => state.muidrawer.data);
  const GallaryDetail = useAppSelector((state) => state.gallary.GallaryDetail);
  const loading = useAppSelector((state) => state.gallary.formLoading);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (GallaryID) {
      dispatch(getGallaryByID(GallaryID));
    }
    return () => {
      dispatch(clearGallaryDetails());
    };
  }, [GallaryID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [GallaryDetail]);

  const handleSubmit = async (values: any) => {
    const ImgAlt = values?.ImgAlt ? values?.ImgAlt : "";
    const ImageData = new FormData();
    const Image =
      values?.GallaryImage &&
      typeof values?.GallaryImage !== "string" &&
      Array.isArray(values?.GallaryImage) &&
      values?.GallaryImage?.length > 0
        ? values.GallaryImage[0].getRawFile()
        : "";

    try {
      if (GallaryID) {
        if (
          values?.GallaryImage &&
          typeof values?.GallaryImage !== "string" &&
          Array.isArray(values?.GallaryImage) &&
          values?.GallaryImage?.length > 0
        ) {
          ImageData.append("ImgAlt", ImgAlt);
          ImageData.append("ImageFile", Image);
          ImageData.append("ID", GallaryID);
          const response = await dispatch(updateGallary(ImageData));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(getAllGallarys());
            dispatch(clearGallaryDetails());
          }
        }
      } else {
        if (
          values?.GallaryImage &&
          typeof values?.GallaryImage !== "string" &&
          Array.isArray(values?.GallaryImage) &&
          values?.GallaryImage?.length > 0
        ) {
          ImageData.append("ImgAlt", ImgAlt);
          ImageData.append("ImageFile", Image);
          const response = await dispatch(updateGallary(ImageData));
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(closed());
            dispatch(getAllGallarys());
            dispatch(clearGallaryDetails());
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={GallaryDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {GallaryID ? "Update Gallary" : "Create Gallary"}
                  </Typography.h4>
                  <Button
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </Button>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="ImgAlt"
                    label="ImgAlt"
                    placeholder="ImgAlt"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name="GallaryImage"
                    label="Image"
                    type="file"
                    accept="image/*"
                    alternateName="Image"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={GallaryID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateGallary;
